module.exports = __webpack_public_path__ + "img/bg01.12d9cfb9.png";